const fetchAbort = require('./fetch-abort');

const { defaultTimeout } = fetchAbort;
const defaultRetries = 4;

module.exports = (url, options, { retries = defaultRetries, timeout = defaultTimeout } = {}) => {
  let left = retries;
  const attempt = () => {
    // the attempt start here so left must be decreased
    left -= 1;
    return fetchAbort(url, options, timeout)
      .catch((err) => {
        // have not attempts left
        if (left <= 0) {
          throw err;
        }

        return new Promise((resolve, reject) => {
          // Wait time between attempts increases as retries dwindle
          // eg. first retry waits 4ms, second retry waits 16ms, third
          // waits 64ms, fourth waits 256
          // Default sum of wait time for all retries to fail is 340ms
          const waitTimeMilliseconds = 4 ** (retries - left);

          setTimeout(() => {
            attempt()
              .then(resolve)
              .catch(reject);
          }, waitTimeMilliseconds);
        });
      });
  };
  return attempt();
};

module.exports.defaultRetries = defaultRetries;
module.exports.defaultTimeout = defaultTimeout;
